export const AUTH_TOKEN_STORAGE_KEY = '@MPA_reports:authToken';
export const COMPANY_ID_STORAGE_KEY = '@MPA_reports:companyId';
